import type { ActionsObservable } from 'redux-observable';
import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { HandleAjaxError } from '@helpcenter/flags';
import { handleAjaxError } from '@helpcenter/flags';
import { createPassword } from 'rest/login';
import type { CreatePassword, CreatePasswordSuccess } from 'state/actions/login';
import { CREATE_PASSWORD, createPasswordSuccess } from 'state/actions/login';

export const createPasswordEpic: Epic<CreatePassword, CreatePasswordSuccess | HandleAjaxError> = (
	action$: ActionsObservable<CreatePassword>,
) => {
	return action$.ofType(CREATE_PASSWORD).mergeMap((createPasswordAction) => {
		const { resetUrl, email } = createPasswordAction.payload;
		return createPassword(resetUrl, email)
			.map(() => {
				return createPasswordSuccess();
			})
			.catch((error: AjaxError) => {
				return Observable.of(handleAjaxError(error));
			});
	});
};
